import * as React from "react";
import { Field } from "formik";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Select from "components/common/Select";
import { Input } from "components/bootstrap";
const IndexSetSelect = ({ indexSets, label = void 0, help = void 0 }) => {
  const { t } = useTranslation("streams");
  const indexSetOptions = useMemo(
    () => indexSets.filter((indexSet) => indexSet.can_be_default).map(({ id, title }) => ({
      value: id,
      label: title
    })),
    [indexSets]
  );
  return /* @__PURE__ */ React.createElement(Field, { name: "index_set_id" }, ({ field: { name, value, onChange, onBlur }, meta: { error, touched } }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      label: label != null ? label : t("index_set_select.label"),
      help: help != null ? help : t("index_set_select.help"),
      id: name,
      error: error && touched ? error : void 0
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        onBlur,
        onChange: (newValue) => onChange({
          target: { value: newValue, name }
        }),
        options: indexSetOptions,
        inputId: name,
        placeholder: t("index_set_select.placeholder"),
        value
      }
    )
  ));
};
export default IndexSetSelect;
